import * as React from 'react';

import { Constants } from 'risesharp-common';
import { properties } from 'risesharp-ui';

import { General } from './../parentClasses/general';
import { Helper } from './../utils/helper';
import ViewVideo from './../components/viewVideo';
import withTracker from './../layout/withTracker';

const blogImage1 = require('./../images/blog1.jpg');
const blogImage2 = require('./../images/blog2.jpg');
const blogImage3 = require('./../images/blog3.jpg');
const workImage1 = require('./../images/img-1.png');
const workImage2 = require('./../images/img-2.png');
const workImage3 = require('./../images/img-3.png');
const workImage4 = require('./../images/img-4.png');
const video1 = require('./../videos/career-planning.mp4');
const imageFile1 = require('./../videos/career-planning-thumbnail.png');
const store1 = require('./../images/play_store.png');
const store2 = require('./../images/app_store.png');

class StudentsGetStarted extends General {
  constructor(props: React.Props<any>) {
    super(props);
    this.trackContentHeight(true);
    this.displayTopLevelMessages(true);
  }

  componentDidMount() {
    this.trackContentHeight(false);
  }
  
  render() {
    return (
      <React.Fragment>
        {/* title */}
        {this.displayCustomTitleAndMeta(Constants.IDENTIFIER_STUDENT_GETSTARTED)}
        <div className="my-2">
          <div className="container-fluid students-sec students-sec-bg-1 text-center">
            <div className="students-sec-bg-1-t">
              <h3>Get Your Dream Job Out of College</h3>
            </div>
          </div>

          <div className="container students-sec mt-5">
            <div className="col mx-auto text-center">
              <div className="my-3">
                <h4>Download the Free App!</h4>
                <div className="mgn-rgt mgn-btm" style={{ display: "inline-block" }}>
                  <a href="https://play.google.com/store/apps/details?id=com.risesharp.studentApp" target="_blank" rel="noopener">
                    <img className="img-fluid" src={store1} width="210" height="190" alt=""/>
                  </a>
                </div>
                <div style={{ display: "inline-block" }}>
                  <a href="https://apps.apple.com/app/get-job-ready/id6736531308" target="_blank" rel="noopener">
                    <img className="img-fluid" src={store2} width="210" height="190" alt=""/>
                  </a>
                </div>
              </div>
              <br/>
              <h2>Transition from College to Job Successfully</h2>
              <p>
                Jumpstart your journey to your dream job through a well-developed plan and preparation.
              </p>
              <div className="my-4">
                <div className="row">
                  <div className="col-md-8 offset-md-2">
                    <div className="outline">
                      <ViewVideo
                        id={'view_video'}
                        videoUrl={video1}
                        imgUrl={imageFile1}
                        isModal={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container students-sec mt-5">
            <div className="col mx-auto text-center">
              <h4><span>College to Career</span></h4>
              <h2>Helping College Students &amp; Graduates  Reach Their Career Goals</h2>
              <p>
                Our {properties.application.name} Platform will help you plan, prepare and pursue the best path to finding your dream job. Helping you find a job is our top priority!
              </p>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-4 mgn-btm">
                <div className="students-sec-detail-1">
                  <div className="students-sec-detail-1-img">
                    <img src={blogImage1} className="img-fluid" alt=""/>
                  </div>
                  <h2>If you’re in your early years of college</h2>
                  <p>
                    Jumpstart your journey to career through a well-developed plan. Early career planning can help you get into the job of your choice. The key to having a job when you graduate is to begin preparing yourself as early as possible.
                  </p>
                </div>
              </div>
              <div className="col-md-4 mgn-btm">
                <div className="students-sec-detail-1">
                  <div className="students-sec-detail-1-img">
                  <img src={blogImage2} className="img-fluid" alt=""/>
                  </div>
                  <h2>If you’re in your final years of college</h2>
                  <p>
                    Your college journey is fast approaching to its end. Strengthen your resume, and get a head start on the job search process — preparing a resume & cover letter, researching companies, practicing for interview, and planning your job search.
                  </p>
                </div>
              </div>
              <div className="col-md-4 mgn-btm">
                <div className="students-sec-detail-1">
                  <div className="students-sec-detail-1-img">
                    <img src={blogImage3} className="img-fluid" alt="" />
                  </div>
                  <h2>If you already graduated from college</h2>
                  <p>
                    Whether you already started your job search, or looking to start a search, {properties.application.name} can help you prepare and present the best foot forward to achieve your job and career goals. Gain access to resources &amp; stay connected to the community.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4 text-center" style={{ padding: "15px" }}>
            <h4>Download the Free App!</h4>
            <div className="mgn-rgt mgn-btm" style={{ display: "inline-block" }}>
              <a href="https://play.google.com/store/apps/details?id=com.risesharp.studentApp" target="_blank" rel="noopener">
                <img className="img-fluid" src={store1} width="210" height="190" alt=""/>
              </a>
            </div>
            <div style={{ display: "inline-block" }}>
              <a href="https://apps.apple.com/app/get-job-ready/id6736531308" target="_blank" rel="noopener">
                <img className="img-fluid" src={store2} width="210" height="190" alt=""/>
              </a>
            </div>
          </div>
          <div className="container students-sec students-sec-bg-2 mt-5 py-3">
            <div className="row">
              <div className="col mx-auto text-center">
                <h4><span>How it Works</span></h4>
                <h2>How The {properties.application.name} Platform Works</h2>
                <p>
                  Leverage {properties.application.name} to prepare for the professional world and secure a job. No matter when you begin, our approach covers every step of the way.
                </p>
              </div>
            </div>
            <div className="students-sec-detail-2">
              <div className="row">
                <div className="col-md-4">
                  <img src={workImage1} className="img-fluid" alt=""/>
                </div>
                <div className="col-md-8">
                  <h2><strong>1<span>. </span>ASSESS</strong></h2>
                  <p>
                    Conduct assessments to learn about your career goals, interests, values, skills, and preferences.
                  </p>
                  <h3>Features</h3>
                  <ul>
                    <li>Know what’s important to you, including criteria for your career selection</li>
                    <li>Receive guidance that covers such areas as personality types, motivational traits and top job areas to pursue</li>
                    <li>Define and clarify your academic and professional goals</li>
                    <li>Explore your career possibilities: identify all the choices that are available to you as you consider your career path, both short-term and long-term</li>
                    <li>Review the current market trends, opportunities and challenges impacting your field of interest</li>
                  </ul>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <img src={workImage2} className="img-fluid" alt=""/>
                </div>
                <div className="col-md-8">
                <h2><strong>2<span>. </span>PREPARE </strong></h2>
                <p>
                  Develop strategies to achieve your professional goals, and prepare to increase confidence and motivation to be successful in your job search.
                </p>
                <h3>Features</h3>
                <ul>
                  <li>Develop resume and cover letter with guidance from a professional resume writer, including creating a version of resume to post on online job search directories
                  </li>
                  <li>Establish a polished, professional online presence (LinkedIn Profile, Profile on Job Search Sites)</li>
                  <li>Get interview advice to help learn the art of interviewing: Review interviewing strategies, tips and best practices</li>
                  <li>Prepare for a library of most commonly asked interview questions, including approaches to answering them -- Questions on education, Questions on experience, Behavioral questions, Questions about Strengths and Weaknesses, Questions about salary, Open-Ended questions</li>
                  <li>Prepare to ask an interviewer questions to show your interest and gauge “fit”, including company culture</li>
                  <li>Practice mock interview sessions</li>
                </ul>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <img src={workImage3} className="img-fluid" alt=""/>
                </div>
                <div className="col-md-8">
                  <h2><strong>3<span>. </span>PLAN </strong> </h2>
                  <p>
                    Develop the plan, step-by-step, through the complete career planning and job search process.
                  </p>
                  <h3>Features</h3>
                  <ul>
                    <li>Develop job search strategy and timeline</li><br/>
                    <li>Map out the best plan of action while in college</li>
                    <li>Create a “best fit” companies list matched to your job goals and career interests</li>
                    <li>Learn how to research companies and job roles, and how to make the best impression in a competitive job market</li>
                  </ul>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <img src={workImage4} className="img-fluid" alt=""/>
                </div>
                <div className="col-md-8">
                  <h2><strong>4<span>. </span>EXECUTE</strong></h2>
                  <p>
                    Connect with employers for job opportunities, including internships and other experiential learning experiences.
                  </p>
                  <h3>Features</h3>
                  <ul>
                    <li>Leverage the internal and external job boards to identify internship and other job opportunities</li>
                    <li>Build professional, Job-Ready skills through class projects, volunteer opportunities, summer internships and other experiential learning opportunities</li>
                    <li>Maximize your career opportunities by improving your employment marketability and job opportunities</li>
                    <li>Conduct an ongoing progress review to address any job search challenges and to refine job searching strategies &amp; tactics</li>
                    <li>Gain access to guidance on follow-up communications and salary negotiation strategies</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4 text-center" style={{ padding: "15px" }}>
            <h4>Download the Free App!</h4>
            <div className="mgn-rgt mgn-btm" style={{ display: "inline-block" }}>
              <a href="https://play.google.com/store/apps/details?id=com.risesharp.studentApp" target="_blank" rel="noopener">
                <img className="img-fluid" src={store1} width="210" height="190" alt=""/>
              </a>
            </div>
            <div style={{ display: "inline-block" }}>
              <a href="https://apps.apple.com/app/get-job-ready/id6736531308" target="_blank" rel="noopener">
                <img className="img-fluid" src={store2} width="210" height="190" alt=""/>
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  // display sections
  private displayCustomTitleAndMeta(identifier: string) {
    return this.getHelmetData({
      identifier,
      college_name: Helper.getCollegeName(this.props)
    });
  }
}

export default withTracker(StudentsGetStarted);
